import axios from 'axios';
import { API_GATEWAY_URL } from '../actions/urlTypes';

// export const getSmartSearchData = data =>
//   new Promise((resolve, reject) => {
//     const elasticSearchJavaUrl = `${API_GATEWAY_URL}/api/dictionary-service/search`;
//     axios({
//       url: elasticSearchJavaUrl,
//       method: 'post',
//       headers: {
//         Accept: 'application/json;charset=UTF-8',
//       },
//       data: data.body,
//     })
//       .then(response => {
//         // console.dir(response.data);
//         resolve(response.data);
//       })
//       .catch(response => reject(response));
//   });

  export const getSmartSearchData = data =>
  new Promise((resolve, reject) => {
    const elasticSearchJavaUrl = `${API_GATEWAY_URL}/api/dictionary-service/msearch`;
    axios({
      url: elasticSearchJavaUrl,
      method: 'post',
      headers: {
        Accept: 'application/json;charset=UTF-8',
      },
      data: data.body,
      withCredentials: true,
    })
      .then(response => {
        // console.dir(response.data);
        resolve(response.data);
      })
      .catch(response => reject(response));
  });
